import { Link, useLocation } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Menus from '../ListGroups/Menus';

const useStyles = makeStyles((theme) => ({
    AnchorMenuItem: {
        textDecoration: 'none',
        color: theme.palette.text.primary,
        fontWeight: 500,
        whiteSpace: 'nowrap',
        transition: 'color 0.2s ease',
        '&:hover': {
            color: theme.palette.primary.main,
        },
    },
    NavMobile: {
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        marginBottom: '100px',
        paddingLeft: '24px',
        '& a': {
            fontSize: '1.375rem',
            padding: '10px 0',
            marginLeft: '24px',
        },
    },
    NavDesktop: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: '4px',
        paddingBottom: '12px',
        '& a': {
            fontSize: '1.125rem',
            padding: '8px 10px',
        },
    },
    NavActive: {
        color: `${theme.palette.primary.main} !important`,
        fontWeight: 700,
        borderBottom: `2px solid ${theme.palette.primary.main}`,
    },
}));

const Menu = () => {
    const classes = useStyles();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('md'));
    const location = useLocation();
    const pathname = location.pathname;

    return (
        <Box
            component="nav"
            className={matches ? classes.NavDesktop : classes.NavMobile}
        >
            {Menus.map((item, index) => {
                const activeClass = pathname === item.Href ? classes.NavActive : '';
                return (
                    <Link
                        key={index}
                        state={{ anchor: 'default' }}
                        to={item.Href}
                        className={`${classes.AnchorMenuItem} ${activeClass}`}
                    >
                        {item.Text}
                    </Link>
                );
            })}
        </Box>
    );
};

export default Menu;
